import { ArcgisCivil3dCogoPointSettingApiModel } from '../../../types/models/arcgis-civil3d-cogo-point-setting.model';
import { GetArcgisCivil3dCogoPointSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/get-arcgis-civil3d-cogo-point-setting.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { SearchArcgisCivil3dCogoPointSettingsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/search-arcgis-civil3d-cogo-point-settings.request';
import { DeleteArcgisCivil3dCogoPointSettingsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/delete-arcgis-civil3d-cogo-point-settings.request';
import { CreateArcgisCivil3dFeatureLineSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/create-arcgis-civil3d-feature-line-setting.request';
import { UpdateArcgisCivil3dCogoPointSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/update-arcgis-civil3d-cogo-point-setting.request';
import { ArcgisCivil3dPropertyMappingApiModel } from '../../../types/models/arcgis-civil3d-property-mapping.model';
import { CreatePropertyMappingForCogoPointApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/create-property-mapping-for-cogo-point.request';
import { DeletePropertyMappingForCogoPointApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/delete-property-mapping-for-cogo-point.request';
import { GetAllPropertyMappingsForCogoPointApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/get-all-property-mappings-for-cogo-point.request';
import { UpdatePropertyMappingsForCogoPointApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/update-property-mappings-for-cogo-point.request';
import { DuplicateArcgisCivil3dCogoPointsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/duplicate-arcgis-civil3d-cogo-point-settings.request';
import { CreatePropertyMappingsForCogoPointsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/create-property-mappings-for-cogo-points.request';
import { SearchPropertyMappingsForCogoPointsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/cogo-points/search-property-mappings-for-cogo-points.request';

export const createCogoPointSetting = (params: CreateArcgisCivil3dFeatureLineSettingApiRequest) =>
  client.post<ArcgisCivil3dCogoPointSettingApiModel>('/arcgis-civil3d-settings/cogo-points', params);

export const updateCogoPointSetting = ({ cogoPointId, ...params }: UpdateArcgisCivil3dCogoPointSettingApiRequest) =>
  client.patch<ArcgisCivil3dCogoPointSettingApiModel>(`/arcgis-civil3d-settings/cogo-points/${cogoPointId}`, params);

export const getCogoPointSetting = <T extends ArcgisCivil3dCogoPointSettingApiModel>({
  cogoPointId,
  ...params
}: GetArcgisCivil3dCogoPointSettingApiRequest) =>
  client.get<T>(`/arcgis-civil3d-settings/cogo-points/${cogoPointId}`, { params });

export const searchCogoPointSettings = <T extends ArcgisCivil3dCogoPointSettingApiModel>(
  params: SearchArcgisCivil3dCogoPointSettingsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/cogo-points`, { params });

export const deleteCogoPointSettings = ({ cogoPointIds, ...params }: DeleteArcgisCivil3dCogoPointSettingsApiRequest) =>
  client.delete<ArcgisCivil3dCogoPointSettingApiModel>(`/arcgis-civil3d-settings/cogo-points`, {
    data: { cogoPointIds },
    ...params,
  });

export const duplicateCogoPointSettings = (params: DuplicateArcgisCivil3dCogoPointsApiRequest) =>
  client.post<ArcgisCivil3dCogoPointSettingApiModel[]>(`/arcgis-civil3d-settings/cogo-points/duplicate`, params);

export const searchPropertyMappingsForCogoPoints = <T extends ArcgisCivil3dPropertyMappingApiModel>(
  params: SearchPropertyMappingsForCogoPointsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/cogo-points/property-mappings`, { params });

export const createPropertyMappingForCogoPoint = ({
  cogoPointId,
  ...params
}: CreatePropertyMappingForCogoPointApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/cogo-points/${cogoPointId}/property-mappings`,
    { params },
  );

export const createPropertyMappingsForCogoPoints = (params: CreatePropertyMappingsForCogoPointsApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/cogo-points/property-mappings`,
    params,
  );

export const updatePropertyMappingsForCogoPoint = ({
  cogoPointId,
  ...params
}: UpdatePropertyMappingsForCogoPointApiRequest) =>
  client.patch<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/cogo-points/${cogoPointId}/property-mappings`,
    params,
  );

export const getAllPropertyMappingsForCogoPoint = ({ cogoPointId }: GetAllPropertyMappingsForCogoPointApiRequest) =>
  client.get<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/cogo-points/${cogoPointId}/property-mappings`,
  );

export const deletePropertyMappingFromCogoPoint = ({
  cogoPointId,
  civil3dPropertyId,
}: DeletePropertyMappingForCogoPointApiRequest) =>
  client.delete<void>(`/arcgis-civil3d-settings/cogo-points/${cogoPointId}/property-mappings/${civil3dPropertyId}`);
